export default __webpack_public_path__ + "static/media/pAVAX.21deda8f.svg";